"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rollbackSpectrumByFilter = exports.rollbackSpectrum = exports.handleSignalProcessingFilter = exports.handleDeleteExclusionZone = exports.handleAddExclusionZone = exports.handleSetFilterSnapshotHandler = exports.handleBaseLineCorrectionFilter = exports.handleDeleteSpectraFilter = exports.handleDeleteFilter = exports.handleEnableFilter = exports.handleCalculateZeroFillingFilter = exports.handleCalculateApodizationFilter = exports.handleCalculateBaseLineCorrection = exports.calculateBaseLineCorrection = exports.handleCalculateManualPhaseCorrection = exports.handleApplyAbsoluteFilter = exports.handleApplyAutoPhaseCorrectionFilter = exports.handleApplyManualPhaseCorrectionFilter = exports.handleApplyFFtDimension2Filter = exports.handleApplyFFtDimension1Filter = exports.handleApplyFFTFilter = exports.handleApplyApodizationFilter = exports.handleApplyZeroFillingFilter = exports.handleShiftSpectrumAlongXAxis = void 0;
const uuid_1 = require("@lukeed/uuid");
const immer_1 = require("immer");
const nmr_processing_1 = require("nmr-processing");
const DefaultApodizationOptions_1 = require("../../../data/constants/DefaultApodizationOptions");
const ToolTypes_1 = require("../../toolbar/ToolTypes");
const getSpectraByNucleus_1 = require("../../utility/getSpectraByNucleus");
const nucleusToString_1 = __importDefault(require("../../utility/nucleusToString"));
const Reducer_1 = require("../Reducer");
const ZoomHistoryManager_1 = __importDefault(require("../helper/ZoomHistoryManager"));
const getActiveSpectrum_1 = require("../helper/getActiveSpectrum");
const getRange_1 = __importDefault(require("../helper/getRange"));
const getStrongestPeak_1 = require("../helper/getStrongestPeak");
const DomainActions_1 = require("./DomainActions");
const PreferencesActions_1 = require("./PreferencesActions");
const ToolsActions_1 = require("./ToolsActions");
const getSpectrum_1 = require("../helper/getSpectrum");
const { fft, fftDimension1, fftDimension2, apodization, baselineCorrection, phaseCorrection, zeroFilling, shiftX, shift2DX, shift2DY, exclusionZones, signalProcessing, } = nmr_processing_1.Filters;
function getFilterUpdateDomainRules(filterName) {
    return (nmr_processing_1.Filters[filterName]?.DOMAIN_UPDATE_RULES || {
        updateXDomain: false,
        updateYDomain: false,
    });
}
function rollbackSpectrumByFilter(draft, options) {
    const { applyFilter = true, searchBy = 'id', reset = false, key, activeSpectrum, triggerSource = 'none', } = options || {};
    const currentActiveSpectrum = activeSpectrum || (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    let updateDomainOptions = {
        updateXDomain: false,
        updateYDomain: false,
    };
    let previousIsFid = false;
    let currentIsFid = false;
    if (currentActiveSpectrum) {
        const index = currentActiveSpectrum.index;
        const datum = draft.data[index];
        previousIsFid = datum.info.isFid;
        const filterIndex = datum.filters.findIndex((f) => f[searchBy] === key);
        const activeFilterId = draft.toolOptions.data.activeFilterID;
        if (filterIndex !== -1 && !reset) {
            const filters = datum.filters.slice(0, filterIndex || 1);
            //set active filter
            draft.toolOptions.data.activeFilterID = datum.filters[filterIndex]?.id;
            if (filters.length > 0) {
                for (let i = 0; i <= filterIndex; i++) {
                    const { updateXDomain, updateYDomain } = getFilterUpdateDomainRules(datum.filters[i].name);
                    updateDomainOptions.updateXDomain =
                        updateXDomain || updateDomainOptions.updateXDomain;
                    updateDomainOptions.updateYDomain =
                        updateYDomain || updateDomainOptions.updateYDomain;
                }
                nmr_processing_1.FiltersManager.reapplyFilters(datum, filters);
            }
            draft.tempData = (0, immer_1.current)(draft).data;
            // apply the current Filters
            if (applyFilter) {
                nmr_processing_1.FiltersManager.reapplyFilters(datum, datum.filters.slice(0, filterIndex + 1));
            }
            currentIsFid = datum.info.isFid;
            //if we still point to the same filter then close the filter options panel and reset the selected tool to default one (zoom tool)
            if (activeFilterId === datum.filters[filterIndex].id &&
                triggerSource === 'Apply') {
                draft.toolOptions.selectedOptionPanel = null;
                draft.toolOptions.selectedTool = 'zoom';
            }
        }
        else {
            //if the filter is not exists, create a clone of the current data
            draft.tempData = (0, immer_1.current)(draft).data;
        }
        // re-implement all filters and rest all view property that related to filters
        if (reset) {
            draft.tempData = null;
            nmr_processing_1.FiltersManager.reapplyFilters(datum);
            updateDomainOptions = { updateXDomain: true, updateYDomain: true };
            const { toolOptions: { data }, } = (0, Reducer_1.getInitialState)();
            draft.toolOptions.data = data;
            draft.toolOptions.selectedOptionPanel = null;
            draft.toolOptions.selectedTool = 'zoom';
            currentIsFid = datum.info.isFid;
        }
    }
    (0, DomainActions_1.setDomain)(draft, updateDomainOptions);
    if (previousIsFid !== currentIsFid) {
        (0, DomainActions_1.setMode)(draft);
        (0, PreferencesActions_1.changeSpectrumVerticalAlignment)(draft, { verticalAlign: 'auto-check' });
    }
}
exports.rollbackSpectrumByFilter = rollbackSpectrumByFilter;
function rollbackSpectrum(draft, options) {
    const { filterKey, reset = false, updateFilterViewOptions = true } = options;
    //return back the spectra data to point of time before applying a specific filter
    const applyFilter = [
        phaseCorrection.id,
        fft.id,
        shiftX.id,
        shift2DX.id,
        shift2DY.id,
        signalProcessing.id,
    ].includes(filterKey);
    rollbackSpectrumByFilter(draft, {
        searchBy: 'name',
        key: filterKey,
        applyFilter,
        reset,
    });
    if (updateFilterViewOptions) {
        updateFilterOptionsInView(draft, filterKey);
    }
}
exports.rollbackSpectrum = rollbackSpectrum;
function updateFilterOptionsInView(draft, filterKey) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    switch (filterKey) {
        case phaseCorrection.id: {
            // look for the strongest peak to set it as a pivot
            const { xValue, index } = (0, getStrongestPeak_1.getStrongestPeak)(draft) || {
                xValue: 0,
                index: 0,
            };
            draft.toolOptions.data.pivot = { value: xValue, index };
            break;
        }
        case baselineCorrection.id: {
            if (activeSpectrum) {
                const baselineCorrectionFilter = (0, immer_1.current)(draft).data[activeSpectrum.index].filters.find((filter) => filter.name === ToolTypes_1.options.baselineCorrection.id);
                if (baselineCorrectionFilter) {
                    draft.toolOptions.data.baselineCorrection.zones =
                        baselineCorrectionFilter
                            ? baselineCorrectionFilter.value.zones
                            : [];
                }
            }
            break;
        }
        case apodization.id: {
            draft.toolOptions.data.apodizationOptions = DefaultApodizationOptions_1.defaultApodizationOptions;
            break;
        }
        default:
            break;
    }
}
/**
 * getActiveFilterIndex return active filter index. Otherwise, its returns -1
 */
function getActiveFilterIndex(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    const id = draft.toolOptions.data.activeFilterID;
    if (id && activeSpectrum) {
        const spectrum = draft.data[activeSpectrum.index];
        const index = spectrum.filters.findIndex((filter) => filter.id === id);
        return index;
    }
    return -1;
}
function updateView(draft, filterUpdateDomainRules) {
    draft.tempData = null;
    const { updateXDomain, updateYDomain } = filterUpdateDomainRules;
    const spectrum = (0, getSpectrum_1.getSpectrum)(draft);
    (0, ToolsActions_1.resetSelectedTool)(draft);
    (0, DomainActions_1.setDomain)(draft, { updateXDomain, updateYDomain });
    if (spectrum) {
        (0, DomainActions_1.setIntegralsYDomain)(draft, spectrum);
    }
    (0, DomainActions_1.setMode)(draft);
    (0, PreferencesActions_1.changeSpectrumVerticalAlignment)(draft, { verticalAlign: 'auto-check' });
}
function disableLivePreview(draft, id) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const index = activeSpectrum.index;
        const { data } = draft.tempData[index];
        draft.data[index].data = data;
        (0, DomainActions_1.setDomain)(draft);
        // reset default options
        switch (id) {
            case apodization.name: {
                draft.toolOptions.data.apodizationOptions = DefaultApodizationOptions_1.defaultApodizationOptions;
                break;
            }
            default: {
                return null;
            }
        }
    }
}
//action
function handleShiftSpectrumAlongXAxis(draft, action) {
    //apply filter into the spectrum
    const { shift } = action.payload;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const activeFilterIndex = getActiveFilterIndex(draft);
        const index = activeSpectrum?.index;
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [
            { name: shiftX.id, value: { shift } },
        ]);
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: shiftX.id,
                triggerSource: 'Apply',
            });
        }
        else {
            updateView(draft, shiftX.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleShiftSpectrumAlongXAxis = handleShiftSpectrumAlongXAxis;
//action
function handleApplyZeroFillingFilter(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const activeFilterIndex = getActiveFilterIndex(draft);
        const index = activeSpectrum.index;
        const filters = [
            {
                name: zeroFilling.id,
                value: action.payload.options,
            },
        ];
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], filters, {
            filterIndex: activeFilterIndex,
        });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: zeroFilling.id,
                triggerSource: 'Apply',
            });
        }
        else {
            updateView(draft, zeroFilling.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleApplyZeroFillingFilter = handleApplyZeroFillingFilter;
//action
function handleCalculateZeroFillingFilter(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { options, livePreview } = action.payload;
        if (livePreview) {
            const index = activeSpectrum.index;
            const { data: { x, re, im }, filters, info, } = draft.tempData[index];
            const _data = { data: { x, re, im }, filters, info };
            zeroFilling.apply(_data, options);
            const { im: newIm, re: newRe, x: newX } = _data.data;
            const datum = draft.data[index];
            datum.data.x = newX;
            datum.data.im = newIm;
            datum.data.re = newRe;
            draft.xDomain = [newX[0], newX.at(-1)];
        }
        else {
            disableLivePreview(draft, zeroFilling.name);
        }
    }
}
exports.handleCalculateZeroFillingFilter = handleCalculateZeroFillingFilter;
//action
function handleCalculateApodizationFilter(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const index = activeSpectrum.index;
        const { livePreview, options } = action.payload;
        if (livePreview) {
            const { data: { x, re, im }, info, } = draft.tempData[index];
            const _data = { data: { x, re, im }, info };
            draft.toolOptions.data.apodizationOptions = options;
            apodization.apply(_data, options);
            const { im: newIm, re: newRe } = _data.data;
            const datum = draft.data[index];
            datum.data.im = newIm;
            datum.data.re = newRe;
        }
        else {
            disableLivePreview(draft, apodization.name);
        }
    }
}
exports.handleCalculateApodizationFilter = handleCalculateApodizationFilter;
//action
function handleApplyApodizationFilter(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const index = activeSpectrum.index;
        const activeFilterIndex = getActiveFilterIndex(draft);
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [
            {
                name: apodization.id,
                value: action.payload.options,
            },
        ], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: apodization.id,
                triggerSource: 'Apply',
            });
        }
        else {
            updateView(draft, apodization.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleApplyApodizationFilter = handleApplyApodizationFilter;
//action
function handleApplyFFTFilter(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const activeFilterIndex = getActiveFilterIndex(draft);
        //apply filter into the spectrum
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [{ name: fft.id, value: {} }], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: fft.id,
            });
        }
        else {
            updateView(draft, fft.DOMAIN_UPDATE_RULES);
        }
        //clear zoom history
        draft.zoom.history[draft.view.spectra.activeTab] = [];
    }
}
exports.handleApplyFFTFilter = handleApplyFFTFilter;
function handleApplyFFtDimension1Filter(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const activeFilterIndex = getActiveFilterIndex(draft);
        //apply filter into the spectrum
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [{ name: fftDimension1.id, value: {} }], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: fftDimension1.id,
            });
        }
        else {
            updateView(draft, fftDimension1.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleApplyFFtDimension1Filter = handleApplyFFtDimension1Filter;
function handleApplyFFtDimension2Filter(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const activeFilterIndex = getActiveFilterIndex(draft);
        //apply filter into the spectrum
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [{ name: fftDimension2.id, value: {} }], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: fftDimension2.id,
            });
        }
        else {
            updateView(draft, fftDimension2.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleApplyFFtDimension2Filter = handleApplyFFtDimension2Filter;
//action
function handleApplyManualPhaseCorrectionFilter(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const { ph0, ph1 } = action.payload;
        draft.data = draft.tempData;
        const activeFilterIndex = getActiveFilterIndex(draft);
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [
            {
                name: phaseCorrection.id,
                value: { ph0, ph1 },
            },
        ], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: phaseCorrection.id,
                triggerSource: 'Apply',
            });
        }
        else {
            updateView(draft, phaseCorrection.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleApplyManualPhaseCorrectionFilter = handleApplyManualPhaseCorrectionFilter;
//action
function handleCalculateManualPhaseCorrection(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const { data: { x, re, im }, info, } = draft.tempData[index];
        const { ph0, ph1 } = action.payload;
        const _data = { data: { x, re, im }, info };
        phaseCorrection.apply(_data, { ph0, ph1 });
        const { im: newIm, re: newRe } = _data.data;
        const datum = draft.data[index];
        datum.data.im = newIm;
        datum.data.re = newRe;
    }
}
exports.handleCalculateManualPhaseCorrection = handleCalculateManualPhaseCorrection;
//action
function handleApplyAbsoluteFilter(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const activeFilterIndex = getActiveFilterIndex(draft);
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [
            {
                name: phaseCorrection.id,
                value: { absolute: true },
            },
        ], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: phaseCorrection.id,
                triggerSource: 'Apply',
            });
        }
        else {
            updateView(draft, phaseCorrection.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleApplyAbsoluteFilter = handleApplyAbsoluteFilter;
//action
function handleApplyAutoPhaseCorrectionFilter(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const activeFilterIndex = getActiveFilterIndex(draft);
        nmr_processing_1.FiltersManager.applyFilter(draft.data[index], [
            {
                name: phaseCorrection.id,
                value: {},
            },
        ], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: phaseCorrection.id,
                triggerSource: 'Apply',
            });
        }
        else {
            updateView(draft, phaseCorrection.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleApplyAutoPhaseCorrectionFilter = handleApplyAutoPhaseCorrectionFilter;
//action
function handleBaseLineCorrectionFilter(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { zones } = draft.toolOptions.data.baselineCorrection;
        const { options } = action.payload;
        const activeFilterIndex = getActiveFilterIndex(draft);
        nmr_processing_1.FiltersManager.applyFilter(draft.data[activeSpectrum.index], [
            {
                name: baselineCorrection.id,
                value: {
                    ...options,
                    zones,
                },
            },
        ], { filterIndex: activeFilterIndex });
        if (activeFilterIndex !== -1) {
            rollbackSpectrumByFilter(draft, {
                searchBy: 'name',
                key: baselineCorrection.id,
                triggerSource: 'Apply',
            });
        }
        else {
            updateView(draft, baselineCorrection.DOMAIN_UPDATE_RULES);
        }
    }
}
exports.handleBaseLineCorrectionFilter = handleBaseLineCorrectionFilter;
function calculateBaseLineCorrection(draft, baseLineOptions) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const { data: { x, re, im }, info, } = draft.tempData[index];
        // save the baseline options temporary
        draft.toolOptions.data.baselineCorrection = {
            ...draft.toolOptions.data.baselineCorrection,
            ...(baseLineOptions && baseLineOptions),
        };
        const { zones, options, livePreview } = draft.toolOptions.data.baselineCorrection;
        if (livePreview) {
            const _data = { data: { x, re, im }, info };
            baselineCorrection.apply(_data, {
                zones,
                ...options,
            });
            const { im: newIm, re: newRe } = _data.data;
            const datum = draft.data[index];
            datum.data.im = newIm;
            datum.data.re = newRe;
        }
        else {
            disableLivePreview(draft, baselineCorrection.id);
        }
    }
}
exports.calculateBaseLineCorrection = calculateBaseLineCorrection;
//action
function handleCalculateBaseLineCorrection(draft, action) {
    calculateBaseLineCorrection(draft, action.payload);
}
exports.handleCalculateBaseLineCorrection = handleCalculateBaseLineCorrection;
//action
function handleEnableFilter(draft, action) {
    const { id: filterID, enabled } = action.payload;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        //apply filter into the spectrum
        nmr_processing_1.FiltersManager.enableFilter(draft.data[activeSpectrum.index], filterID, enabled);
        (0, ToolsActions_1.resetSelectedTool)(draft);
        (0, DomainActions_1.setDomain)(draft);
        (0, DomainActions_1.setMode)(draft);
        const zoomHistory = (0, ZoomHistoryManager_1.default)(draft.zoom.history, draft.view.spectra.activeTab);
        const zoomValue = zoomHistory.getLast();
        if (zoomValue) {
            draft.xDomain = zoomValue.xDomain;
            draft.yDomain = zoomValue.yDomain;
        }
    }
}
exports.handleEnableFilter = handleEnableFilter;
//action
function handleDeleteFilter(draft, action) {
    const filterID = action?.payload?.id;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        //apply filter into the spectrum
        nmr_processing_1.FiltersManager.deleteFilter(draft.data[activeSpectrum.index], filterID);
        draft.toolOptions.data.activeFilterID = null;
        (0, ToolsActions_1.resetSelectedTool)(draft);
        (0, DomainActions_1.setDomain)(draft);
        (0, DomainActions_1.setMode)(draft);
    }
}
exports.handleDeleteFilter = handleDeleteFilter;
//action
function handleDeleteSpectraFilter(draft, action) {
    const filterName = action.payload.filterName;
    if (draft.view.spectra.activeTab) {
        for (const datum of draft.data) {
            if ((0, nucleusToString_1.default)(datum?.info?.nucleus) === draft.view.spectra.activeTab) {
                const filtersResult = datum.filters?.filter((filter) => filter.name === filterName) || [];
                for (const filter of filtersResult) {
                    nmr_processing_1.FiltersManager.deleteFilter(datum, filter.id);
                }
            }
        }
        (0, ToolsActions_1.resetSelectedTool)(draft);
        (0, DomainActions_1.setDomain)(draft);
        (0, DomainActions_1.setMode)(draft);
    }
}
exports.handleDeleteSpectraFilter = handleDeleteSpectraFilter;
//action
function handleSetFilterSnapshotHandler(draft, action) {
    const { name: filterKey, id } = action.payload;
    const reset = draft.toolOptions.data.activeFilterID === id;
    if (ToolTypes_1.options?.[filterKey]?.isFilter) {
        (0, ToolsActions_1.activateTool)(draft, { toolId: filterKey, reset });
    }
    else {
        (0, ToolsActions_1.resetSelectedTool)(draft);
        rollbackSpectrum(draft, { filterKey, reset });
    }
}
exports.handleSetFilterSnapshotHandler = handleSetFilterSnapshotHandler;
//action
function handleSignalProcessingFilter(draft, action) {
    const { data, view } = draft;
    const nucleus = view.spectra.activeTab;
    const value = action.payload.options;
    const activeFilterIndex = getActiveFilterIndex(draft);
    const spectra = (0, getSpectraByNucleus_1.getSpectraByNucleus)(nucleus, data);
    for (const spectrum of spectra) {
        nmr_processing_1.FiltersManager.applyFilter(spectrum, [
            {
                name: signalProcessing.id,
                value,
            },
        ], { filterIndex: activeFilterIndex });
    }
    const { updateXDomain, updateYDomain } = signalProcessing.DOMAIN_UPDATE_RULES;
    (0, DomainActions_1.setDomain)(draft, { updateXDomain, updateYDomain });
}
exports.handleSignalProcessingFilter = handleSignalProcessingFilter;
//action
function handleAddExclusionZone(draft, action) {
    const { startX, endX } = action.payload;
    const range = (0, getRange_1.default)(draft, { startX, endX });
    let spectra;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum?.id) {
        const index = activeSpectrum?.index;
        spectra = [draft.data[index]];
    }
    else {
        spectra = (0, getSpectraByNucleus_1.getSpectraByNucleus)(draft.view.spectra.activeTab, draft.data);
    }
    for (const spectrum of spectra) {
        nmr_processing_1.FiltersManager.applyFilter(spectrum, [
            {
                name: exclusionZones.id,
                value: [
                    {
                        id: (0, uuid_1.v4)(),
                        from: range[0],
                        to: range[1],
                    },
                ],
            },
        ]);
    }
    const { updateXDomain, updateYDomain } = exclusionZones.DOMAIN_UPDATE_RULES;
    (0, DomainActions_1.setDomain)(draft, { updateXDomain, updateYDomain });
}
exports.handleAddExclusionZone = handleAddExclusionZone;
//action
function handleDeleteExclusionZone(draft, action) {
    const { zone, spectrumId } = action.payload;
    // if spectrum id exists, remove the selected exclusion zone in the spectrum
    if (spectrumId) {
        const spectrumIndex = draft.data.findIndex((spectrum) => spectrum.id === spectrumId);
        const filter = draft.data[spectrumIndex].filters.find((_filter) => _filter.name === exclusionZones.id);
        if (filter) {
            if (filter.value.length === 1) {
                nmr_processing_1.FiltersManager.deleteFilter(draft.data[spectrumIndex], filter.id);
            }
            else {
                filter.value = filter.value.filter((_zone) => _zone.id !== zone?.id);
                nmr_processing_1.FiltersManager.reapplyFilters(draft.data[spectrumIndex]);
            }
        }
    }
    else {
        // remove all exclusion zones that have the same range in all spectra
        const data = (0, getSpectraByNucleus_1.getSpectraByNucleus)(draft.view.spectra.activeTab, draft.data);
        for (const datum of data) {
            for (const filter of datum.filters) {
                if (filter.name === exclusionZones.id) {
                    filter.value = filter.value.filter((_zone) => zone.from !== _zone.from && zone.to !== _zone.to);
                    nmr_processing_1.FiltersManager.reapplyFilters(datum);
                }
            }
        }
    }
}
exports.handleDeleteExclusionZone = handleDeleteExclusionZone;
